/**
 * Clicking the rating summary near the price (stars + review count) smooth-
 * scrolls down to the "Product Reviews" section instead of doing a native
 * instant jump. Delegated on `document` so it works regardless of how many
 * times this block/script appear on the page, and degrades gracefully to a
 * plain anchor jump if this script fails to load (href="#product-reviews").
 */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-scroll-to-reviews]');
  if (!trigger) return;

  const target = document.getElementById('product-reviews');
  if (!target) return; // let the native "#product-reviews" jump no-op instead

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
